import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "Components/Header";
import Footer from "Components/Footer";
import DiffResult from "Components/DiffResult";
import { fixoApi } from "Api";

const CorrectionResult = ({
  match: {
    params: { id },
  },
}) => {
  const [originArr, setOriginArr] = useState([]); // 유저가 쓴 원본
  const [revisionArr, setRevisionArr] = useState([]); // 첨삭 후 수정본

  const getOriginData = async () => {
    const res = await fixoApi.getCorrectResult(id);
    const clearData = JSON.parse(JSON.stringify(res)); //원본 데이터 참조를 제거 후 복사
    setOriginArr(res.data.statement); //원본 데이터를 originArr state에 저장
    setRevisionArr(clearData.data.statement); // 참조 제거된 원본 데이터를 revisionArr state에 저장
  };

  useEffect(() => {
    getOriginData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <Header />
      <Main>
        {revisionArr.length > 0 &&
          revisionArr.map((el) => (
            <DiffResult
              id={el.id - 1}
              revisionArr={revisionArr}
              originText={originArr[el.id - 1].answer}
            />
          ))}
      </Main>
      <Footer />
    </Container>
  );
};

export default CorrectionResult;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
  td {
    padding: 0 10px !important;
    height: 0 !important;
    border: 0 !important;
  }
`;

const Main = styled.section`
  max-width: 1200px;
  margin: 0px auto;
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;
